export const IF_OPEN_KEYWORD = "#if";
export const ELSE_KEYWORD = "else";
export const IF_CLOSE_KEYWORD = "/if";
export const ELSE_TOKEN = `{{${ELSE_KEYWORD}}}`;
export const IF_CLOSE_TOKEN = `{{${IF_CLOSE_KEYWORD}}}`;
export const IF_OPEN_TOKEN_START = `{{${IF_OPEN_KEYWORD}`;
export const BLOCK_TOKEN_PATTERN = /\{\{#if\s+([^}]+?)\}\}|\{\{\s*else\s*\}\}|\{\{\s*\/if\s*\}\}/g;
export const IF_OPEN_CONTENT_PATTERN = /^#if\s+(.+)$/;
export function createBlockTokenRegex() {
    return new RegExp(BLOCK_TOKEN_PATTERN.source, "g");
}
export function buildIfOpenToken({ expression }) {
    return `{{${IF_OPEN_KEYWORD} ${expression}}}`;
}
export function readTokenContent(token) {
    return token.replace(/^\{\{/, "").replace(/\}\}$/, "").trim();
}
export function readIfOpenExpression(content) {
    return content.trim().match(IF_OPEN_CONTENT_PATTERN)?.[1].trim();
}
export function isElseContent(content) {
    return content.trim() === ELSE_KEYWORD;
}
export function isIfCloseContent(content) {
    return content.trim() === IF_CLOSE_KEYWORD;
}
